export default __webpack_public_path__ + "static/media/2004.61b1320a.png";